import { render, staticRenderFns } from "./NpRecognitionEdit.vue?vue&type=template&id=66e78b93"
import script from "./NpRecognitionEdit.vue?vue&type=script&lang=js"
export * from "./NpRecognitionEdit.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionEdit.vue?vue&type=style&index=0&id=66e78b93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports